angular.module('tf.services')

    .factory('HttpInterceptorService',['$location','$injector','$q','$rootScope','$timeout',function($location, $injector, $q, $rootScope, $timeout){

        function alert(response, delay){
            var alert = response.headers('tf-alert');
            if(alert){
                if(delay){
                    $timeout(function(){
                        $rootScope.$broadcast('tf-alert',{message: alert, type : response.headers('tf-alert-type'), duration : response.headers('tf-alert-duration')});
                    }, delay);
                } else {
                    $rootScope.$broadcast('tf-alert',{message: alert, type : response.headers('tf-alert-type'), duration : response.headers('tf-alert-duration')});
                }
                return;

            }

            alert = response.headers('tf-alert-popup');
            if(alert){
                $rootScope.$broadcast('tf-popup',{message: alert, type : response.headers('tf-alert-type'), duration : response.headers('tf-alert-duration')});
                return;
            }
        }



        return {
            'request': function (config) {
                return config;
            },

            'response': function (response) {


                var alertDelay = 0;
                var redirect = response.headers('redirectTo');
                if(redirect){
                    if($location.path() != redirect && $location.path() != ("/"+redirect)) {
                        alertDelay = 100;
                        $location.path(redirect);

                    }
                }
                alert(response, alertDelay);
                return response;
            },

            'responseError': function (response) {

                var alertDelay = 0;
                var redirect = response.headers('redirectTo');
                if(redirect){
                    var state = $injector.get('$state');
                    if(state.current.name != redirect && state.current.name != "/"+redirect) {
                        state.go(redirect, {error: response.data});
                        alertDelay = 100;
                    }
                }
                alert(response, alertDelay);
                return $q.reject(response);
            }
        };


    }])
;
